// extracted by mini-css-extract-plugin
export default {"container":"_2S3fs","error":"_1iPWc","center":"_2mjnx","content":"_2vjDB","close":"_1hBcC","mobile":"_3ZEnN","hidden":"EOym3"};